<mat-grid-list [cols]="12" rowHeight="125px">
  <mat-grid-tile [colspan]="6">
    <mat-form-field [style.width]="'96%'">
      <mat-label>Key</mat-label>
      <input matInput placeholder="Key Name" [formControl]="key" required />
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile>
    <div class="rh-btn-container">
      <button class="rh-list-btn" mat-button (click)="introspect()" [disabled]="key.invalid">Introspect</button>
    </div>
  </mat-grid-tile>
</mat-grid-list>